module.exports = __webpack_public_path__ + "media/images/favicon-cbdd485f.png";